import { render, staticRenderFns } from "./AddCommentDialog.vue?vue&type=template&id=fe8b669c&"
import script from "./AddCommentDialog.js?vue&type=script&lang=js&"
export * from "./AddCommentDialog.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports